import axios, { Canceler } from 'axios';
import dayjs from 'dayjs';
import Decimal from 'decimal.js';
import { detectIncognito } from 'detectincognitojs';
import md5 from 'md5';
import { makeAutoObservable } from 'mobx';

import { get_awardconfig, need_bind_phone, recharge_view_better } from '@/api/hall';
import { implog } from '@/api/implog';
import { login, whatsappShareBind } from '@/api/login';
import { getBalanceInfo, getUserPhone } from '@/api/user';
import { ACCESS_TOKEN_KEY, ACCESS_USER_NAME, ACCESS_USERID_KEY, YK_BIND_PHONE_KEY } from '@/constant/config';
import { getQueryParam } from '@/hooks/useParam';
import { history } from '@/routers/history';
import { isInApk, saveUserID } from '@/utils/apk';
import { initSourceurl } from '@/utils/cookie';
import Storage from '@/utils/Storage';
import { getDevice, getUrlParam, inPwaEnv, isPwaSource, openKefu } from '@/utils/utils';

import { gameStore } from './game';
import { modalStore } from './modal';

interface Advertisement {
  name: string;
  title: string;
  duration: string;
  start: string;
  end: string;
  game: string;
}

interface Config {
  version: string;
  remark: string;
  check_during: number;
  advertise: Advertisement[];
}

export function getCurrentAdvertisement(config: Config): Advertisement | null {
  const currentTime = dayjs();

  for (const ad of config.advertise) {
    const startTime = dayjs(ad.start).startOf('day');
    const endTime = dayjs(ad.end).endOf('day');

    if (currentTime.isAfter(startTime) && currentTime.isBefore(endTime)) {
      return ad;
    }
  }

  return null;
}
const CancelToken = axios.CancelToken;
let cancel: Canceler | null = null;

const initialState: Record<string, any> = {
  name: 'user',
  isLogin: false,
  isLoading: true,
  is_bind_mobile: 0, //是否绑定手机
  h5cashablemoney: 0, //可提现金额
  score: 0, //当前携带
  cashnum: 0, //当日提现次数
  cashnum_share: 0, //分享提现次数
  viplevel: 0, //vip等级
  vippoint: 0, //vip点数
  showWithdrawGuide: false, //是否显示提现引导
  isFirstLogin: false, //是否首次登录
  vipurl: '',
  nextvipurl: '',
  user_phone: Storage.get(YK_BIND_PHONE_KEY) || '',
  registerDate: '',
  whatsapp_lb: { cash_can: 0, resetflag: 0, score_fetch: 0, score: 0 },
  withdraw_min: 40 // 游戏内提现
};

export type InitialFreeWithdrawInfoType = {
  cash_default: number;
  cash_free_can: number;
  bet_need_cashfree: number;
  bet_left_cashfree: number;
  score_free: number;
  score: number; // 用户提现金额
  percent: number;
  bet_need_cashfree_usdt: number;
  cash_default_usdt: number;
};

const initialFreeWithdrawInfo: InitialFreeWithdrawInfoType = {
  cash_default: 0, // 可提现金额
  cash_free_can: 0, // 可提现金额
  bet_need_cashfree: 0, // 目标流水
  bet_left_cashfree: 0, // 当前流水
  score_free: 0, // 用户提现金额
  percent: 0,
  score: 0,
  bet_need_cashfree_usdt: 0, // usdt 的目标流水
  cash_default_usdt: 0 // usdt 的可提现金额
};

const initialAwardconfig = {
  mobilereg: 15,
  guestreg: 10,
  mobilebind: 5
};

const advertise: Advertisement = {
  name: 'fruit2000',
  title: 'Ganhe $2000+!',
  duration: '18/06 0:00 - 20/06 24:00',
  start: '2024-06-18',
  end: '2024-06-20',
  game: 'ermj'
};
interface WithdrawTaskInfo {
  bet: number;
  bet_use: number;
  bet_left: number;
  cash20: number;
  cash40: number;
  lastcash: number;
  score_free: number;
  task_list: any[];
  tab_list: any[];
  cur_step: any;
  cfg: any;
  open_step: number;
}
const withdrawTaskInfo: WithdrawTaskInfo = {
  bet: 0,
  bet_use: 0,
  bet_left: 0,
  cash20: 2500,
  cash40: 5000,
  lastcash: 40,
  score_free: 0,
  task_list: [],
  tab_list: [],
  cur_step: {},
  cfg: {},
  open_step: 0
};
const getFbcAndFbpPromise = (): Promise<any> => {
  return new Promise(resolve => {
    getFbcAndFbp(resolve);
  });
};
const userInfo: Record<string, any> = {};
/**
 * 判断账号id是否以target结尾
 * @param numberString 账号id
 * @param target 可选值 ['0', '1']，为空时返回true
 * @returns
 */
export function useridEndsWith(numberString, target = ['0', '1']) {
  try {
    const lastChar = numberString[numberString.length - 1];
    return target?.includes(lastChar);
  } catch (error) {
    return false;
  }
}
export const globalStore = makeAutoObservable({
  initialState,
  initialFreeWithdrawInfo,
  initialAwardconfig,
  advertise,
  isPostPwaServer: false,
  resetflag: false, //是否显示裂变弹窗
  userInfo,
  withdrawTaskInfo, //提现任务信息
  isTestRecharge: false,
  freeFlag: 3,
  isTestFirstRecharge: false,
  testFirstRechargePrice: 9.99,
  isNeedBindPhone: false,
  isTestServicer: !window?.privateConfig?.hideTestServicer,
  isTestFreeWithdraw: false,
  isTestRechargeViewBetter: false,

  onGlobalStateChange(state: any) {
    for (const key in state) {
      globalStore.initialState[key] = state[key];
    }
  },
  setIsFirstLogin(isFirstLogin: boolean) {
    this.initialState.isFirstLogin = isFirstLogin;
  },

  resetTestFirstRecharge() {
    if (getAPKCHSource()?.includes('H5US4FR01')) {
      this.isTestFirstRecharge = true;
      const userid = Storage.getAccess(ACCESS_USERID_KEY) || '';
      if (useridEndsWith(`${userid}`, ['0', '1', '2', '3'])) {
        this.testFirstRechargePrice = 9.99;
      } else if (useridEndsWith(`${userid}`, ['4', '5', '6'])) {
        this.testFirstRechargePrice = 12.99;
      } else if (useridEndsWith(`${userid}`, ['7', '8', '9'])) {
        this.testFirstRechargePrice = 14.99;
      }
    } else {
      this.isTestFirstRecharge = false;
      this.testFirstRechargePrice = 9.99;
    }
  },

  resetTestFreeWithdraw() {
    const userid = Storage.getAccess(ACCESS_USERID_KEY) || '';
    this.isTestFreeWithdraw = useridEndsWith(`${userid}`, ['1', '3', '5', '7', '9']);
  },

  getFreeWithdrawPath() {
    return this.isTestFreeWithdraw ? '/withdraw/free/new' : '/withdraw/free';
  },

  resetData() {
    //用户切换账号有些数据需要重置
    this.resetTestFirstRecharge();
    this.resetTestFreeWithdraw();
  },

  async initConfig() {
    try {
      await Promise.all([
        this.fetchBalance(),
        this.get_awardconfig(),
        this.get_need_bind_phone(),
        this.get_recharge_view_better()
      ]);
    } catch (e) {
      console.log(e);
    }
    this.isTestRecharge = useridEndsWith(`${Storage.getAccess(ACCESS_USERID_KEY) || ''}`, ['2', '3']);
    this.isTestServicer = !window?.privateConfig?.hideTestServicer;
    this.resetData();
    // this.isTestServicer =
    //   __PRODUCT_NAME__ === 'goldSlot' || window?.privateConfig?.code === 'fish' || window?.privateConfig?.hz
    //     ? false
    //     : true;

    this.initialState.isLoading = false;
  },

  async fetchBalance() {
    const token = Storage.getAccess(ACCESS_TOKEN_KEY);
    if (!token) return;
    try {
      const data = await getBalanceInfo({
        cancelToken: new CancelToken(function (c) {
          cancel = c;
        })
      });
      if (data.ret === 0) {
        const { viplevel = 0, score } = data.ps;
        this.onGlobalStateChange({
          ...data.ps,
          vipurl: `${window.imgPrefix}/img/vip/v${viplevel}.webp`,
          nextvipurl: `${window.imgPrefix}/img/vip/v${viplevel + 1}.webp`,
          showWithdrawGuide: viplevel === 0 && score > 200,
          isLogin: true
        });
        globalStore.resetflag = !!data?.ps?.whatsapp_lb?.resetflag;
        // const response = await fetch(`/app_version.json?v=${Math.random()}&md5=${token}`);
        // if (!response.ok) {
        //   throw new Error('Network response was not ok');
        // }
        // const res: Config = await response.json();
        // const advertise = getCurrentAdvertisement(res);
        // if (advertise) this.advertise = advertise;
        await this.getFreeWithdrawInfo();
        isInApk() && saveUserID(Storage.getAccess(ACCESS_USERID_KEY));
      }
      if (data.ret === -1 && data.code === 1 && data.msg) {
        modalStore.openRejectLogin(data?.msg);
        return;
      }
    } catch (e) {
      console.log(e);
    }

    return this.initialState;
  },
  async get_awardconfig() {
    const data = await get_awardconfig();
    if (data.ret === 0) {
      this.initialAwardconfig = data.record;
    }
  },
  async get_need_bind_phone() {
    const data = await need_bind_phone();
    if (data.ret === 0) {
      this.isNeedBindPhone = !!data?.data;
    }
  },
  async get_recharge_view_better() {
    const data = await recharge_view_better();
    if (data.ret === 0) {
      this.isTestRechargeViewBetter = !!data?.data || window.privateConfig?.rechargeViewBetter;
    }
  },
  async getBalanceInfo() {
    try {
      const data = await getBalanceInfo({
        cancelToken: new CancelToken(function (c) {
          cancel = c;
        })
      });
      const { viplevel = 0 } = data.ps;
      this.onGlobalStateChange({
        ...data.ps,
        vipurl: `${window.imgPrefix}/img/vip/v${viplevel}.webp`,
        nextvipurl: `${window.imgPrefix}/img/vip/v${viplevel + 1}.webp`
      });
      globalStore.resetflag = !!data?.ps?.whatsapp_lb?.resetflag;
    } catch (e) {
      console.log(e);
    }
    this.initialState.isLoading = false;
    return this.initialState;
  },
  async logout() {
    const userid = Storage.getAccess(ACCESS_USERID_KEY);
    implog('normal_logout', '', userid);
    this.initialState.isLogin = false;
    this.initialState.isFirstLogin = false;

    if (cancel) cancel('cancel request');

    history.push?.('/login');
  },
  async touristsLogin(uuid, needRefresh = false) {
    try {
      gameStore.showLoading();
      initSourceurl();
      const incognito = await detectIncognito();
      let uniqueId = uuid;
      // 如果非隐身模式 读取cookie 唯一值
      if (!incognito.isPrivate) {
        uniqueId = await getUniqueID();
      }

      let newuuid = uniqueId;

      if (incognito.isPrivate) {
        // 前四位替换为ysms
        newuuid = newuuid.replace(newuuid.substr(0, 4), 'ysms');
      }

      const params = await getFbcAndFbpPromise();
      const account = `GUEST${uniqueId}`;
      const device = getDevice();

      const args: any = {
        ad: params['ad'],
        ad_id: params['ad_id'],
        adset: params['adset'],
        adset_id: params['adset_id'],
        campaign: params['campaign'],
        campaign_id: params['campaign_id'],
        fbclid: params['_fbc'],
        fbpid: params['_fbp'],
        pixel: params['pixel'],
        straccounts: account,
        strpassword: `${md5(account + 'pb555dkrq2aq')}`,
        uuid: newuuid,
        cbgender: device === 'ios' ? 1 : 0
      };

      const BASE_URL = getAPKCHSource().replace('CH_', '') || 'H5US4MAIN_001';
      const pushfrom = getQueryParam('pushfrom');

      if (pushfrom) {
        args.p_source = `${BASE_URL}_${pushfrom}`;
      }
      if (isPwaSource() && inPwaEnv()) {
        if (device === 'ios') {
          args['ios_collect'] = 1;
        } else {
          args['open_from'] = 1;
        }
      }
      const data = await login(args);
      if (data?.code) {
        gameStore.hideLoading();
        modalStore.openRejectLogin(data.err);
        return Promise.reject(data);
      }
      this.onGlobalStateChange({
        isLogin: true
      });
      const parent_uid = getUrlParam('puid');
      const phone = getUrlParam('sp');
      if (parent_uid) {
        whatsappShareBind({
          clip: `parent_uid=${parent_uid}&source=${getAPKCHSource()}&channel=${getAPKCHSource()}`,
          ua: navigator?.userAgent,
          userid: data.userid,
          source: getAPKCHSource(),
          phone
        });
      }
      Storage.setAccess(ACCESS_TOKEN_KEY, data.token);
      Storage.setAccess(ACCESS_USERID_KEY, data.userid);
      Storage.setAccess(ACCESS_USER_NAME, data.nickname);

      implog('login&register', inPwaEnv() ? 'in_pwa' : 'in_web', data.userid);
      const push_callback = Storage.get('push_callback');
      const push_callback_register = Storage.get('push_callback_register');
      if (push_callback && !push_callback_register) {
        Storage.set('push_callback_register', '1');
        implog('push_hall_show_register', '', data.userid);
      }

      if (data.isFirstLogin) {
        globalStore.setIsFirstLogin(true);
        const fbqReqRemark = `${params?.['pixel'] || ''}|${params?.['_fbc'] || ''}|${
          params?.['_fbp'] || ''
        }|CompleteRegistration|${data?.userid || ''}|${phone || ''}||${navigator?.userAgent || ''}`;
        implog('fbqReq', fbqReqRemark?.slice(0, 1023), data.userid);
        if (typeof fbq === 'function' && !!fbq) {
          setTimeout(() => {
            fbq('track', 'CompleteRegistration', {}, { eventID: data.userid });
          }, 2000);
        }
      } else {
        globalStore.setIsFirstLogin(false);
      }
      if (needRefresh) await globalStore.fetchBalance();
      gameStore.hideLoading();
    } catch (e) {
      gameStore.hideLoading();
      console.log(e, 'touristlogin in catch');
    }
  },
  async getFreeWithdrawInfo() {
    try {
      const p_userid = Storage.getAccess(ACCESS_USERID_KEY);
      const res = await getUserPhone({ p_userid, p_gameid: 3 });
      let [
        {
          cash_default = 0,
          cash_free_can = 0,
          bet_need_cashfree = 0,
          bet_left_cashfree = 0,
          score_free = 0,
          score = 0,
          bet_need_cashfree_usdt = 0,
          cash_default_usdt = 0
        }
      ] = res.record;
      cash_default = Decimal.div(cash_default, 1000).toNumber();
      cash_default_usdt = Decimal.div(cash_default_usdt, 1000).toNumber();
      cash_free_can = Decimal.div(cash_free_can, 1000).toNumber();
      bet_need_cashfree = Decimal.div(bet_need_cashfree, 1000).toNumber();
      bet_need_cashfree_usdt = Decimal.div(bet_need_cashfree_usdt, 1000).toNumber();
      bet_left_cashfree = Decimal.div(bet_left_cashfree, 1000).toNumber();
      score_free = Decimal.div(score_free, 1000).toNumber();
      score = Decimal.div(score, 1000).toNumber();
      let percent = Decimal.div(bet_left_cashfree, bet_need_cashfree).mul(100).toNumber();
      percent = percent > 100 ? 100 : percent;
      this.initialFreeWithdrawInfo = {
        cash_default,
        cash_default_usdt,
        cash_free_can,
        bet_need_cashfree,
        bet_need_cashfree_usdt,
        bet_left_cashfree,
        score_free,
        score,
        percent: percent || 0
      };
      const [{ mobile, registerdate }] = res.record;
      this.initialState.user_phone = mobile;
      this.initialState.registerDate = registerdate;
      Storage.set(YK_BIND_PHONE_KEY, mobile);
      this.userInfo = res.record[0];
    } catch (e) {
      console.log(e);
    }
  },
  async getUserPhone() {
    try {
      const data = await getUserPhone({ p_userid: Storage.getAccess(ACCESS_USERID_KEY), p_gameid: 3 });
      const [{ mobile, registerdate }] = data.record;
      this.initialState.user_phone = mobile;
      this.initialState.registerDate = registerdate;
      Storage.set(YK_BIND_PHONE_KEY, mobile);
      this.userInfo = data.record[0];
    } catch (e) {
      console.log(e);
    }
  },
  setUserPhone() {
    this.initialState.user_phone = Storage.get(YK_BIND_PHONE_KEY);
  },
  getEnticeVersion() {
    return globalStore.freeFlag;
  }
});

// reaction(
//   () => globalStore.initialState.isLogin,
//   () => {
//     if (globalStore.initialState.isLogin) {
//       globalStore.getUserPhone();
//     }
//   }
// );

export default globalStore;
